import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("fa_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("fa_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (artwork) => {
    setItems((prev) => {
      if (prev.find((i) => i.id === artwork.id)) {
        toast.info("Cette œuvre est déjà dans votre panier");
        return prev;
      }
      toast.success(`« ${artwork.title} » ajouté au panier`);
      return [...prev, artwork];
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clearCart = () => setItems([]);
  const total = items.reduce((sum, i) => sum + Number(i.price || 0), 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, total, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
}
